import { isString } from 'lib';
import {
  MATCH_KEYWORD_OPERATORS,
  MATCH_OPERATORS,
  MOBILE_REGEX,
} from './regex';

export const isAnEmail = (_value) => {
  return _value.match(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
};

export const isValidMobileNumber = (mobileNumber) => {
  if (!isString(mobileNumber)) {
    return false;
  }
  return MOBILE_REGEX.test(mobileNumber);
};

export const isMatchOperators = (value) => {
  if (!isString(value)) {
    return false;
  }
  return value.match(MATCH_OPERATORS);
};

/**
 * Tells a query-based search apart from a plain name/phrase search. A search
 * counts as a query when it carries a logical operator, written either as the
 * AND / OR / NOT keyword or as its symbol in the query builder (* + !).
 */
export const isQueryBasedSearch = (value) => {
  if (!isString(value)) {
    return false;
  }
  return !!isMatchOperators(value) || MATCH_KEYWORD_OPERATORS.test(value);
};

/**
 * Resource searches run as full-text only for a plain name/phrase. A
 * query-based search must reach the backend without the full_text flag.
 */
export const getResourceSearchFullText = (searchText) => {
  return isQueryBasedSearch(searchText) ? undefined : 1;
};

export const isMobile = () => {
  const isMobileRegex =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i;
  return isMobileRegex.test(navigator.userAgent);
};

export const isMatchWithAdvancePasswordConditions = (_value) => {
  return _value.match(
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,}$/
  );
};

export const isNumber = (_value) => {
  return _value.match(/^[0-9]+$/);
};

export const isMatchWithExcelTitleConditions = (_value) => {
  return _value.match(/^[a-zA-Z0-9-_]*$/);
};

export const isSpecialCharacter = (char = '') => {
  return char.match(
    /(\s+|&|,|،|@|<|>|_|-|\?|؛|#|:|;|\.|\(|\)|~|\$|{|}|"|'|]|«|»|!|؟)/
  );
};

export const highlighterRegex = (words) => {
  return new RegExp(
    `(\\s+|&|,|،|@|<|>|_|-|\\?|؛|#|:|;|\\.|\\(|\\)|~|\\$|{|}|"|'|]|«|»|!|؟|^)(${words})(\\s+|&|,|،|@|<|>|_|-|\\?|؛|#|:|;|\\.|\\(|\\)|~|$|{|}|"|'|]|«|»|!|؟|$)`,
    'gim'
  );
};

export const getExclamationMarkCount = (_value) => {
  return (_value.match(/!/g) || []).length;
};

export const getPlusAndAsteriskMarksCount = (_value) => {
  return (_value.match(/[*+]/g) || []).length;
};

export const isUrlExistsInString = (_string) => {
  return _string.match(
    /(?:(?:https?):\/\/)?(?:www\.)?[a-z0-9-]+\.[a-z]{2,}(?:\/[^\s]*)?/gi
  );
};

export const removeUrlProtocolParts = (_string) => {
  if (isUrlExistsInString(_string)) {
    const urlRegex =
      /(?:(?:https?|ftp):\/\/)?(?:www\.)?([a-z0-9-]+\.[a-z]{2,})(?:\/[^\s]*)?/gi;
    return _string.replace(urlRegex, '$1');
  }

  return _string;
};

export const isArabicOrPersian = (value) => {
  const arabicPersianRegex =
    /[\u0600-\u06FF\u0750-\u077F\uFB50-\uFBC1\uFE70-\uFEFC]/;
  return arabicPersianRegex.test(value);
};

export const isInfluenceResource = (influence) => {
  return influence === 'high' || influence === 'highest';
};

export const isTagContainsSpecialCharacters = (value) => {
  return /[!@#$%^?؟&*)(_[\]{}|\\:;"'><,.\-/+=]/.test(value);
};

export const MAX_FILE_NAME_LENGTH = 128;
export const sanitizeFileName = (value) => {
  const allowedCharsRegex =
    /[^a-zA-Z0-9\u06F0-\u06F9\u0621-\u064A\u06A9\u067E\u0686\u0698\u06AF\u06CC\u0640_\- ]/g;
  return value.replace(allowedCharsRegex, '').slice(0, MAX_FILE_NAME_LENGTH);
};
